/* istanbul ignore file */
import Vue from "vue";

const eventhub = new Vue();
export default eventhub;
